import { axios } from '@/services/axios';

export const uploadTemplateImage = (templateId, imageFile) => {
    const formData = new FormData();
    formData.append('file', imageFile);

    return axios.post(`/AATemplate/${templateId}/Image`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};
